<template>
  <v-autocomplete
    v-model="localValue"
    :return-object="true"
    :multiple="true"
    :items="items"
    :item-text="selectedItemToText"
    :search-input.sync="search"
    :loading="loading"
    :error-messages="errors[0]"
    :error="failed"
    :success="showValidation ? passed : undefined"
    :chips="chips"
    :clearable="clearable"
    :deletable-chips="deletableChips"
    :small-chips="smallChips"
    :outlined="outlined"
    :rounded="rounded"
    :dense="dense"
    :single-line="singleLine"
    :label="label"
    :placeholder="showPlaceholder"
    :disabled="disabled"
    :messages="messages"
    :prepend-inner-icon="prependInnerIcon"
    :counter="showCounter"
    :no-filter="noFilter"
    @change="$emit('change', $event)"
    @click:clear="loadItems()"
  >
    <template v-slot:prepend-item>
      <v-row class="d-flex v-list-item">
        <slot name="prepend-item"></slot>
      </v-row>
    </template>
    <template v-slot:item="data">
      <v-row class="d-flex" style="width: 100%">
        <slot name="item" :data="data"></slot>
      </v-row>
    </template>
  </v-autocomplete>
</template>

<script>
import MultipleAutocomplete from './MultipleAutocomplete';

export default {
  mixins: [MultipleAutocomplete],
  props: {
    value: { type: Array, default: () => [] }
  }
};
</script>

<style scoped></style>
